var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cms-card"},[_c('div',{staticClass:"cms-card--header"},[_c('div',{staticClass:"cms-card--header-title-wrapper"},[_vm._t("icon"),_vm._v(" "),_c('h3',[_vm._t("cardTitle")],2)],2),_vm._v(" "),_c('div',{staticClass:"cms-card--header-actions"},[_vm._t("header-actions")],2)]),_vm._v(" "),_c('div',{staticClass:"cms-card--content"},[_vm._t("default")],2)])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-101def64","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/cms/CMSCard.vue
// module id = EICK
// module chunks = 0 1